import React from 'react'

export default class DataSourcePresenterDataDetails extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div className="panel panel-default" >
        <div className="panel-body">
          <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, marginTop: 5, marginBottom: 15 }}>{I18n.t('data_source_details')}</h3>
          <div className="container row">
            <div className="col-md-2">
              <div className="form-group">
                <label>{`${I18n.t('code')}`}</label>
                <p>{this.props.data_source.code}</p>
              </div>
            </div>
            <div className="col-md-2">
              <label>{`${I18n.t('name')}`}</label>
              <div className="form-group">
                <p>{I18n.t(this.props.data_source.name)}</p>
              </div>
            </div>
            <div className="col-md-2">
              <label>{`${I18n.t('status')}`}</label>
              <div className="form-group">
                <p>{I18n.t(this.props.data_source.status)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

}